const isIndividualFlag = (value: unknown) => value === true || value === 'true';

export const parseDebtorInfo = (guest: any) => {
	const info = guest?.DebtorInfo;
	if (!info) return null;
	if (typeof info === 'string') {
		try {
			return JSON.parse(info);
		} catch {
			return null;
		}
	}
	return info;
};

export const folioBuyerIsIndividual = (guest: any) =>
	isIndividualFlag(parseDebtorInfo(guest)?.IsIndividual);

export const einvoiceFromDebtorInfo = (guest: any) => {
	const profile = parseDebtorInfo(guest);
	if (!profile || !isIndividualFlag(profile.IsIndividual)) return null;

	const contact = profile.ContactNo ?? '';

	return {
		einvoice_buyer_name: profile.DebtorName ?? '',
		einvoice_buyer_tin: profile.Tin ?? '',
		einvoice_buyer_regno: profile.CompanyRegNo ?? '',
		einvoice_buyer_address: profile.Address ?? '',
		einvoice_buyer_post_code: profile.postCode ?? '',
		einvoice_buyer_city: profile.City ?? '',
		einvoice_buyer_state: profile.State ?? '',
		einvoice_buyer_country: profile.Country ?? '',
		einvoice_buyer_contact_no:
			typeof contact === 'string' ? contact.replace(/[^+\d]/g, '') : contact,
		einvoice_buyer_identity_type: profile.InvoiceType ?? '',
		einvoice_buyer_email: profile.Email ?? '',
		einvoice_directsend: true,
	};
};
